import React from "react";
import { ChipProps, makeStyles } from "@material-ui/core";
import { store } from "@store";
import { AvatarChip } from "@components";
import UserAvatar, { UserAvatarProps } from "./UserAvatar";

type Props = Partial<Omit<UserAvatarProps, "size">> & {
  ChipProps?: Partial<ChipProps>;
  size: "normal" | "small"; // | "micro";
  noBg?: boolean;
  userName?: string;
  avatarPic?: string;
};

export function UserAvatarChip(props: Props) {
  const { currentUser, userName = "", avatarPic = "" } = props;

  const classes = useStyles({});

  const user = currentUser
    ? store().user.myProfile
    : { AvatarPic: avatarPic, Name: userName };

  return (
    <AvatarChip
      {...props}
      avatarCmp={
        <UserAvatar
          {...props}
          size={
            props.size === "small" ? "mini" : props.size === "normal" ? "small" : "micro"
          }
        />
      }
      className={classes.root}
      size={props.size}
      name={user.Name}
      noBg={props.noBg}
    />
  );
}

const useStyles = makeStyles(() => ({
  root: {
    "& .sb-avatar, & .sb-avatar__image": {
      marginLeft: 0
    }
  }
}));
